import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { BaseModalComponent } from '@app/layout/components/modal-components/base-modal/base-modal.component';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    standalone: false
})
export class ConfirmModalComponent extends BaseModalComponent implements OnInit{
  @Output() logoutEmitter = new EventEmitter();
  ngOnInit() {}

  logout() {
    this.logoutEmitter.emit();
  }

}
